import React, { useState, useRef } from "react";
import "./S1Seach.style.scss";
import S1Input from "../../NavItems/S1input/S1Input.component.jsx";
import { runS1Search } from "../../../utils/functions.ts";
import { usePlayer } from "../../../Contexts/playerData.context.jsx";
import { useDataLayer } from "../../../Contexts/DataLayer.context.jsx";
import { CFLStatus, NFLStatus, heightOptions } from "../../../utils/loadFunctions.ts";
import { USStates } from "../../../utils/loadFunctions.ts";
import { schoolLocations } from "../../../utils/loadFunctions.ts";
import { cflObject } from "../../../utils/loadFunctions.ts";
import { nflObject } from "../../../utils/loadFunctions.ts";
import { ufl24Object } from "../../../utils/loadFunctions.ts";
import { genPos } from "../../../utils/loadFunctions.ts";
import ModDropDown from "../../NavItems/ModDrop/ModDropDown.component.jsx";
import { useNavBar } from "../../../Contexts/navbar.items.context.jsx";
import { startValues } from "../../../utils/loadFunctions.ts";
import refresh from '../../../assets/icons/recycle.svg';
import autorefreshicon from '../../../assets/icons/autoRefresh.svg';
import CustomButton from "../../NavItems/CustomButton/customButton.component.jsx";
import FBXCalendar from "../../Universals/FBXCalendar/fbxcalendar.component.jsx";
import RNFBox from "../../Universals/RNFBox/RNFBox.component.jsx";
import DragBox2026 from "../../Universals/DragBox/DragBox2026/dragBox2026.component.jsx"; // <-- adjust path if needed

const safeJsonParse = (value, fallback) => {
    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};

const S1Search = () => {
    const [S1output, setS1output] = useState(() => {
        const savedOutput = localStorage.getItem("s1output");
        return savedOutput ? JSON.parse(savedOutput) : {}; // Default to {} if not found
    }); // Holds the data for search
    const { setSavedOriginalPlayerData, setPlayerData, setListLoadID, playerID, setPlayerID, setActivePlayer, activePlayer } = usePlayer();
    const { positionArray,
        countryArray,
        schoolArray,
        agentArray,
        autoRefresh,
        updateAutoRefresh,
        updateWhichOneLiner,
        arrayOfShared,  // in FBX this is the SharedOption - or the list of possible shared items set by Dan
        actualShared,
        triggerBlinkSQ
        // these are the actual teams the user has chosen
    } = useDataLayer();

    const [divisionArray, updateDivisionArray] = React.useState([]);
    const [deadSearch, updateDeadSearch] = React.useState(false);
    const [conferenceArray, updateConferenceArray] = React.useState([]);
    const [formValues, setFormValues] = useState(() => {
        const savedOutput = localStorage.getItem("formValues");
        const parsedOutput = savedOutput ? safeJsonParse(savedOutput, null) : null;

        // Always return an object (never null) and ensure any new keys get defaults.
        if (parsedOutput && typeof parsedOutput === "object") {
            return { ...startValues, ...parsedOutput };
        }
        return startValues;
    });

    const { updateActiveSideButton, updateSearchedListName } = useNavBar();
    const updateFormValues = (field, value) => {
        setFormValues((prev) => ({
            ...(prev || {}),
            [field]: value, // Update only the specific field
        }));
    };
    const [specialPick, updateSpecialPick] = useState({
        Country: '-',
        DivisionT: '-',
        Conference: '-',
        theState: '-',
    });

    const blankSpecial = {
        Country: '-',
        DivisionT: '-',
        Conference: '-',
        theState: '-',
        COUNTRY_3: '-',
    };
    const [modifiedSchool, updateModifiedSchool] = useState(schoolArray); // Holds the data for search

    const [loading, setLoading] = useState(false);

    const [dropdownOpen, setDropdownOpen] = useState({
        COL_POS1: false,
        GENPOS: false,
        Country: false,
        DivisionT: false,
        Conference: false,
        theState: false,
        SCHOOL: false,
        schoolCountry: false,
        LAST_SCHOOL: false,
        LAST_SCHOOL_TWO: false,
        playerCountryCode: false,
        AGENTNUM: false,
        HSstars: false,
        HSstars_TO: false,
        HEIGHT: false,
        HEIGHT_TO: false,
        STATE: false,
        HOMESTATE: false,
        CFLTEAM: false,
        CFLSTATUS: false,
        CFLPos: false,
        CFLGP: false,
        IMPNIP: false,
        NFLTEAM: false,
        NFLSTATUS: false,
        NFLPos: false,
        NFLGP: false,
        UFL24TEAM: false,
        UFL24STATUS: false,
        UFL24Pos: false,
        UFL24GP: false,
    });

    const [readyToSearch, setReadyToSearch] = useState(false);

    const lastInputRef = useRef(null); // Ref for LAST input field

    const [openCalendar, setOpenCalendar] = useState(null); // Tracks which calendar is open

    const isBlankValue = (v) => v === null || v === undefined || v === "" || v === "-";
    const hasSearchCriteria = (values = S1output) =>
        !!values && Object.keys(values).length > 0;

    const focusLastNameInput = () => {
        requestAnimationFrame(() => {
            lastInputRef.current?.focus();
        });
    };

    const updateS1OutputArray = (field, value) => {
        setS1output((prev) => {
            const updatedOutput = { ...prev };
            if (isBlankValue(value)) {
                delete updatedOutput[field]; // Clear the field if no value
            } else {
                updatedOutput[field] = value; // Set the new value
            }
            return updatedOutput;
        });

        // Keep formValues in sync (functional update avoids stale state issues)
        setFormValues((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    // When a START date is picked, auto-fill END date (same day) if END is blank.
    // When START is cleared, clear END as well.
    const handleDateChange = (field, value) => {
        updateS1OutputArray(field, value);

        const syncEnd = (startField, endField) => {
            if (field !== startField) return;

            if (isBlankValue(value)) {
                // clearing the start should clear the end
                updateS1OutputArray(endField, null);
                return;
            }

            // If end isn't set yet (null/undefined/''/'-'), set it to match start
            if (isBlankValue(formValues?.[endField])) {
                updateS1OutputArray(endField, value);
            }
        };

        syncEnd("CFLStatusDateStart", "CFLStatusDateEnd");
        syncEnd("NFLStatusDateStart", "NFLStatusDateEnd");
        syncEnd("UFL24StatusDateStart", "UFL24StatusDateEnd");
    };
    React.useEffect(() => {
        const getDivisionData = () => {
            if (divisionArray.length === 0) {
                const newDivisionArray = schoolArray
                    .reduce((acc, school) => {

                        if (
                            school.divisionT &&
                            school.divisionT !== 'none' &&
                            !acc.some((item) => item.divisionT === school.divisionT)
                        ) {

                            acc.push({
                                divisionT: school.divisionT,
                                divisionTOut: school.divisionT,
                            });
                        }
                        return acc;
                    }, [])
                    .sort((a, b) => a.divisionT.localeCompare(b.divisionT));
                updateDivisionArray(newDivisionArray);
            }
        };
        const getConferenceData = () => {
            if (conferenceArray.length === 0) {
                const newConferenceArray = schoolArray
                    .reduce((acc, school) => {
                        if (
                            school.conference &&
                            school.conference !== 'none' &&
                            !acc.some((item) => item.conference === school.conference)
                        ) {
                            acc.push({
                                conference: school.conference,
                                conferenceOut: school.conference,
                            });
                        }
                        return acc;
                    }, [])
                    .sort((a, b) => a.conference.localeCompare(b.conference)); // Sort based on 'conference' field
                updateConferenceArray(newConferenceArray);
            }
        };
        getDivisionData();
        getConferenceData();
        if (lastInputRef.current) {
            lastInputRef.current.focus(); // Automatically focus the "LAST" input on mount
        }

        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        const handleEnterKey = (event) => {
            if (event.key === "Enter") {
                event.preventDefault(); // Prevent default form submission behavior

                // Check if any dropdown is open
                const isAnyDropdownOpen = Object.values(dropdownOpen).some((isOpen) => isOpen);

                if (isAnyDropdownOpen) {

                } else {
                    setReadyToSearch(true);
                }
            }
        };

        document.addEventListener("keydown", handleEnterKey);
        return () => {
            document.removeEventListener("keydown", handleEnterKey);
        };

    }, [dropdownOpen]);

    React.useEffect(() => {
        if (readyToSearch) {
            runTheSearch();
            setReadyToSearch(false); // Reset the flag
        }
        // eslint-disable-next-line
    }, [readyToSearch]);

    // Run the search logic
    // Call this after results arrive (or loading === false)
    const handleSearchResults = (testArray = []) => {
        // 1) Empty set
        if (!Array.isArray(testArray) || testArray.length === 0) {
            updateDeadSearch(true);
            return;
        }

        // 2) API returned a "too many" sentinel
        if (Object.prototype.hasOwnProperty.call(testArray[0] ?? {}, 'playerTotal')) {
            console.log('too many records');
            return;
        }

        // 3) Valid results (single or multiple)
        setPlayerID?.(String(testArray[0].FBXID));
        setActivePlayer?.(testArray[0]);
        updateActiveSideButton?.(null);
        setPlayerData(testArray);
        setSavedOriginalPlayerData(testArray);

        // Kick downstream effects (e.g., OneLiner auto-select)
        setListLoadID(Math.trunc(Math.random() * 1_000_000) + 1);

        if (autoRefresh) {
            refreshAllFields();
        }

        // Optional: if you want to hard-select first record immediately:
        // setPlayerID?.(String(testArray[0].FBXID));
    };


    const runTheSearch = async () => {

        setPlayerData([]); // Clear existing player data
        if (!S1output || Object.keys(S1output).length === 0) {
            setLoading(false);
            return;
        }
        updateDeadSearch(false);
        setLoading(true); // Set loading state to true
        setListLoadID(null); // Reset list load ID
        updateSearchedListName("S1 Search: Regular Search");
        try {
            localStorage.setItem('formValues', JSON.stringify(formValues));
            localStorage.setItem('s1output', JSON.stringify(S1output));
            updateWhichOneLiner(null);
            let testArray = await runS1Search(S1output);
            handleSearchResults(testArray);
            triggerBlinkSQ(); // Trigger Blink SQ
            setLoading(false); // Set loading state to false after search completes
            return;
        } catch {
        } finally {
            setLoading(false); // Reset loading state
        }
    };


    const hsStar = [
        { label: "Zero Star", value: "0" },
        { label: "One Star", value: "1" },
        { label: "Two Star", value: "2" },
        { label: "Three Star", value: "3" },
        { label: "Four Star", value: "4" },
        { label: "Five Star", value: "5" },
    ];

    const chooseNational = [
        { label: "National (Canadian)", value: "N" },
        { label: "American (USA)", value: "U" },
        { label: "Global (All Players Non Can/USA", value: "G" },
        { label: "Veteran American (3 Yrs)", value: "V3" },
        { label: "Vereran American (5 Yrs)", value: "V5" },
    ];


    const refreshAllFields = () => {
        // Reset state values
        setFormValues(startValues);
        setS1output({});
        setOpenCalendar(null);

        // Update localStorage directly to reflect the reset state
        localStorage.setItem('formValues', JSON.stringify(startValues));
        localStorage.setItem('s1output', JSON.stringify({}));

        // Reset other related states
        updateSpecialPick(blankSpecial);
        updateModifiedSchool(schoolArray);
        focusLastNameInput();
    };

    const handleAutoRefreshClick = () => {
        if (!hasSearchCriteria()) {
            focusLastNameInput();
        }
        updateAutoRefresh(!autoRefresh);
    };

    // this is temporary for logging
    React.useEffect(() => {

    }, [specialPick])

    const modifySchoolArray = (field, value) => {
        // Initialize `newSchoolList` to the full `schoolArray`
        let newSchoolList = schoolArray;


        // Reset and update `specialPick` dynamically
        updateSpecialPick({
            ...blankSpecial, // Reset all fields
            [field]: value,  // Update the specific field with the new value
        });
        switch (field) {
            case 'Country':
                if (value === '-') {
                    updateS1OutputArray('COUNTRY_3', '-');
                    updateS1OutputArray('Country', '-');
                } else {
                    newSchoolList = schoolArray.filter(item => item.country === value);
                    const newValue = countryArray.find(item => item.COUNTRY === value);
                    updateS1OutputArray('COUNTRY_3', newValue.CODE_3);
                }
                break;
            case 'theState':
                if (value === '-') {
                    updateS1OutputArray('STATE', '-');
                    updateS1OutputArray('theState', '-');
                } else {
                    newSchoolList = schoolArray.filter(item => item.state.substring(0, 2) === value);
                    updateS1OutputArray('STATE', value);
                    updateS1OutputArray('COUNTRY_3', '-');
                    updateS1OutputArray('DivisionT', '-');
                    updateS1OutputArray('Conference', '-');
                    updateS1OutputArray('Country', '-');
                }
                break;

            case 'DivisionT':
                newSchoolList = schoolArray.filter(item => item.divisionT === value);
                updateS1OutputArray('STATE', '-');
                updateS1OutputArray('COUNTRY_3', '-');
                updateS1OutputArray('DivisionT', value);
                updateS1OutputArray('Conference', '-');
                updateS1OutputArray('Country', '-');
                break;

            case 'Conference':
                newSchoolList = schoolArray.filter(item => item.conference === value);
                updateS1OutputArray('STATE', '-');
                updateS1OutputArray('COUNTRY_3', '-');
                updateS1OutputArray('DivisionT', '-');
                updateS1OutputArray('Conference', value);
                updateS1OutputArray('Country', '-');
                break;

            default:
                // If no criteria match, return the full `schoolArray`
                newSchoolList = schoolArray;
                break;
        }

        // Update the modified school list and form values
        updateModifiedSchool(newSchoolList);
        updateFormValues('SCHOOL', '-');
    };

    const handleDropdownToggle = (field, value, isOpen) => {
        // Log when "HHS" key is changed    
        setDropdownOpen((prev) => ({
            ...Object.keys(prev).reduce((acc, key) => {
                acc[key] = key === field ? isOpen : false; // Only keep the clicked dropdown open
                return acc;
            }, {}),
        }));
    };


    const handleInputFocus = () => {
        setDropdownOpen((prev) =>
            Object.keys(prev).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {})
        );
    };

    const handleToggleCalendar = (fieldName) => {
        if (openCalendar === fieldName) {
            setOpenCalendar(null);
            return;
        }

        setOpenCalendar(fieldName);
    };



    return (
        <DragBox2026
            storageKey="S1SEARCH_DRAGBOX_POS_2026"
            defaultPos={{ x: 57, y: 60 }}
            title="Standard S1 Search"
            headerLeft="Drag"
            onClose={() => updateActiveSideButton(null)}
            minWidth={1280}
            maxWidth={980}
            zIndex={999}
            showReset={true}
        >
            <div className="main-box">
                {/* Action Buttons */}
                <div className="d-flex gap-3 align-items-center mb-3">
                    {/* Left side buttons */}
                    <div className="d-flex gap-1 align-content-center">
                        <button
                            className={`btn ${loading ? "btn-warning" : "btn-success"} text-white px-5`}
                            style={{ width: "200px" }}
                            onClick={runTheSearch}
                            disabled={loading} // Disable the button when loading
                        >
                            {loading ? "Searching..." : "Search"}
                        </button>

                        <button
                            title="Refresh"
                            className="btn btn-danger text-white px-3"
                            onClick={refreshAllFields}>
                            Refresh
                        </button>

                        <CustomButton
                            onClick={handleAutoRefreshClick}
                            isSelected={autoRefresh}
                            background="var(--secondary)"
                            label="Auto Refresh"
                            toolTip="Auto Refresh">
                            Auto Refresh
                        </CustomButton>

                    </div>
                    {deadSearch &&
                        <div className="alert-warning text-center fw-bold px-5" style={{ lineHeight: "35px" }}>This Search Returned No Results</div>
                    }
                    {/* Right side buttons */}
                    <div className="ms-auto d-flex gap-1 alert-dangera align-items-center">
                        <div className="d-flex gap-2 me-2">
                            <RNFBox buttonList={arrayOfShared} selectedButtons={actualShared} />
                        </div>
                    </div>
                </div>


                {/* Input Fields */}
                <div className="s1line">
                    <S1Input
                        ref={lastInputRef}
                        onKeyUpChange={(value) => updateS1OutputArray("LAST", value)}
                        placeholder="Last Name"
                        onFocus={handleInputFocus}
                        percent='16.5%'
                        value={formValues.LAST}
                    />
                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("FIRST", value)}
                        placeholder="First Name"
                        onFocus={handleInputFocus}
                        percent='16.5%'
                        value={formValues.FIRST}
                    />

                    <ModDropDown
                        options={positionArray}
                        field='POS_DESC'
                        fieldValue='POS_SPEC_CODE'
                        fieldName='COL_POS1'
                        label="College Exact Position"
                        percent='16.5%'
                        value={formValues.COL_POS1}
                        isOpen={dropdownOpen.COL_POS1}
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />

                    <ModDropDown
                        options={genPos}
                        field='title'
                        fieldValue='GeneralPos'
                        fieldName='GENPOS'
                        label="College Gen Position"
                        percent='16.5%'
                        value={formValues.GENPOS}
                        isOpen={dropdownOpen.GENPOS}
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />

                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("DRAFT_YEAR", value, 'input')}
                        placeholder="NFL Draft Year"
                        percent='16.5%'
                        value={formValues.DRAFT_YEAR}
                        onFocus={handleInputFocus}
                    />
                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("CFL_DRAFT_YEAR", value, 'input')}
                        placeholder="CFL Draft Year"
                        percent='16.5%'
                        value={formValues.CFL_DRAFT_YEAR}
                        onFocus={handleInputFocus}
                    />
                </div>
                <div className="s1line">
                    <ModDropDown
                        options={countryArray}
                        field="COUNTRY"
                        fieldValue="theCountryName"
                        percent='20%'
                        fieldName='Country'
                        label="Team Country"
                        value={specialPick.Country}
                        isOpen={dropdownOpen.Country}
                        background="rgba(51, 51, 102,.3)"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => modifySchoolArray(field, value)}
                    />
                    <ModDropDown
                        options={divisionArray}
                        field="divisionT"
                        fieldValue="divisionTOut"
                        fieldName='DivisionT'
                        label="Division"
                        percent='20%'
                        value={specialPick.DivisionT}
                        isOpen={dropdownOpen.DivisionT}
                        background="rgba(51, 51, 102,.3)"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => modifySchoolArray(field, value)}
                    />
                    <ModDropDown
                        options={conferenceArray}
                        field="conference"
                        fieldValue="conferenceOut"
                        fieldName='Conference'
                        label="School Conference"
                        percent='20%'
                        value={specialPick.Conference}
                        isOpen={dropdownOpen.Conference}
                        background="rgba(51, 51, 102,.3)"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => modifySchoolArray(field, value)}
                    />
                    <ModDropDown
                        options={USStates}
                        field="name"
                        fieldValue="abbreviation"
                        fieldName='theState'
                        label="Team State/Prov"
                        percent='20%'
                        value={specialPick.theState}
                        isOpen={dropdownOpen.theState}
                        background="rgba(51, 51, 102,.3)"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => modifySchoolArray(field, value)}
                    />
                    <ModDropDown
                        options={modifiedSchool}
                        field="school_short_name"
                        fieldValue="schoolcode"
                        fieldName='SCHOOL'
                        label="School/Team"
                        percent='20%'
                        value={formValues.SCHOOL}
                        isOpen={dropdownOpen.SCHOOL}
                        background="rgba(51, 51, 102,.3)"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                </div>
                <div className="s1line">
                    <ModDropDown
                        options={countryArray}
                        field="COUNTRY"
                        fieldValue="CODE_3"
                        fieldName='playerCountryCode'
                        label="Player Country"
                        value={formValues.playerCountryCode}
                        isOpen={dropdownOpen.playerCountryCode}
                        percent="20%"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                    <ModDropDown
                        options={agentArray}
                        field="LastFirstName"
                        fieldValue="ID"
                        fieldName='AGENTNUM'
                        label="Select Agent"
                        value={formValues.AGENTNUM}
                        isOpen={dropdownOpen.AGENTNUM}
                        percent="20%"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                    <ModDropDown
                        options={hsStar}
                        field="label"
                        fieldValue="value"
                        fieldName='HSstars'
                        label="HS Stars"
                        value={formValues.HSstars}
                        isOpen={dropdownOpen.HSstars}
                        background="rgba(81, 139, 190,.1)"
                        percent="10%"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                    <ModDropDown
                        options={hsStar}
                        field="label"
                        fieldValue="value"
                        fieldName='HSstars_TO'
                        label="HS Stars To"
                        value={formValues.HSstars_TO}
                        isOpen={dropdownOpen.HSstars_TO}
                        background="rgba(81, 139, 190,.1)"
                        percent="10%"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("rateAll", value)}
                        placeholder="Min Rank"
                        percent='10%'
                        background="rgba(102, 16, 242,.1)"
                        value={formValues.rateAll}
                        onFocus={handleInputFocus}
                    />
                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("rateAll_TO", value)}
                        placeholder="Max Rank"
                        percent='10%'
                        value={formValues.rateAll_TO}
                        background="rgba(102, 16, 242,.1)"
                        onFocus={handleInputFocus}
                    />
                    <ModDropDown
                        options={USStates}
                        field="name"
                        fieldValue="abbreviation"
                        fieldName='HOMESTATE'
                        label="Home State/Prov"
                        value={formValues.HOMESTATE}
                        isOpen={dropdownOpen.HOMESTATE}
                        percent="20%"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                </div>
                <div className="s1line">
                    <ModDropDown
                        options={heightOptions}
                        field="label"
                        fieldValue="value"
                        fieldName='HEIGHT'
                        label="Min Height"
                        value={formValues.HEIGHT}
                        isOpen={dropdownOpen.HEIGHT}
                        background="rgba(255, 242, 0,.1)"
                        percent="10%"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                    <ModDropDown
                        options={heightOptions}
                        field="label"
                        fieldValue="value"
                        fieldName='HEIGHT_TO'
                        label="Max Height"
                        value={formValues.HEIGHT_TO}
                        isOpen={dropdownOpen.HEIGHT_TO}
                        background="rgba(255, 242, 0,.1)"
                        percent="10%"
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("WEIGHT", value)}
                        placeholder="Min Weight"
                        percent='10%'
                        value={formValues.WEIGHT}
                        background="rgba(255, 242, 0,.1)"
                        onFocus={handleInputFocus}
                    />
                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("WEIGHT_TO", value)}
                        placeholder="Max Weight"
                        percent='10%'
                        value={formValues.WEIGHT_TO}
                        background="rgba(255, 242, 0,.1)"
                        onFocus={handleInputFocus}
                    />
                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("SPEED40FASTEST", value)}
                        placeholder="Fast Spd"
                        percent='10%'
                        value={formValues.SPEED40FASTEST}
                        background="rgba(255, 242, 0,.1)"
                        onFocus={handleInputFocus}
                    />
                    <S1Input
                        onKeyUpChange={(value) => updateS1OutputArray("SPEED40FASTEST_TO", value)}
                        placeholder="Slow Spd"
                        percent='10%'
                        value={formValues.SPEED40FASTEST_TO}
                        background="rgba(255, 242, 0,.1)"
                        onFocus={handleInputFocus}
                    />
                    <ModDropDown
                        options={schoolLocations}
                        field="name"
                        fieldValue="abbreviation"
                        fieldName='schoolCountry'
                        label="School/Team Location"
                        value={formValues.schoolCountry}
                        isOpen={dropdownOpen.schoolCountry}
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                    <ModDropDown
                        options={schoolArray}
                        field="school_short_name"
                        fieldValue="schoolcode"
                        fieldName='LAST_SCHOOL'
                        label="Prev. School"
                        value={formValues.LAST_SCHOOL}
                        isOpen={dropdownOpen.LAST_SCHOOL}
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                    <ModDropDown
                        options={schoolArray}
                        field="school_short_name"
                        fieldValue="schoolcode"
                        fieldName='LAST_SCHOOL_TWO'
                        label="2nd. Prev School"
                        value={formValues.LAST_SCHOOL_TWO}
                        isOpen={dropdownOpen.LAST_SCHOOL_TWO}
                        onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                        onSelect={(field, value) => updateS1OutputArray(field, value)}
                    />
                </div>


                <div className="cfl container-fluid p-1">
                    <div className="testLine">
                        <ModDropDown
                            options={cflObject}
                            field="Team_Name"
                            fieldValue="Team"
                            fieldName='CFLTEAM'
                            label="CFL Team"
                            value={formValues.CFLTEAM}
                            isOpen={dropdownOpen.CFLTEAM}
                            percent='16.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={CFLStatus}
                            field="status"
                            fieldValue="status_id"
                            fieldName='CFLSTATUS'
                            label="CFL Status"
                            value={formValues.CFLSTATUS}
                            isOpen={dropdownOpen.CFLSTATUS}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={positionArray}
                            field='POS_DESC'
                            fieldValue='POS_SPEC_CODE'
                            fieldName='CFLPos'
                            label="CFL Position"
                            value={formValues.CFLPos}
                            isOpen={dropdownOpen.CFLPos}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={genPos}
                            field='title'
                            fieldValue='GeneralPos'
                            fieldName='CFLGP'
                            label="CFL GP"
                            value={formValues.CFLGP}
                            isOpen={dropdownOpen.CFLGP}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <div className="fixWords px-3 " style={{ flexGrow: "1" }}> Status:</div>
                        <FBXCalendar
                            fieldName='CFLStart'
                            dateIn={formValues.CFLStatusDateStart}
                            minYear="1950"
                            maxYear="2035"
                            style={{ width: '14%' }}
                            placeholder="CFL Status Start"
                            onDateChange={(value) => handleDateChange('CFLStatusDateStart', value)} // Start date handler
                            openCalendar={openCalendar}
                            onToggleCalendar={handleToggleCalendar}
                            isOpen={openCalendar === 'CFLStart'}
                        />
                        <FBXCalendar
                            fieldName='CFLEnd'
                            dateIn={formValues.CFLStatusDateEnd}
                            minYear="1950"
                            maxYear="2035"
                            style={{ width: '14%' }}
                            placeholder="CFL Status End"
                            onDateChange={(value) => handleDateChange('CFLStatusDateEnd', value)} // Start date handler
                            openCalendar={openCalendar}
                            onToggleCalendar={handleToggleCalendar}
                            isOpen={openCalendar === 'CFLEnd'}
                        />
                    </div>
                    <div className="s1line">
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("CFL_DRAFT_YEAR", value)}
                            placeholder="CFL Draft Yr."
                            percent='16.5%'
                            value={formValues.CFL_DRAFT_YEAR}
                            onFocus={handleInputFocus}
                        />
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("CFL_DRAFT_YEAR_TO", value)}
                            placeholder="To CFL Draft Yr."
                            percent='12.5%'
                            value={formValues.CFL_DRAFT_YEAR_TO}
                            onFocus={handleInputFocus}
                        />
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("CFL_DRAFT_ROUND", value)}
                            placeholder="CFL Draft Round"
                            percent='12.5%'
                            value={formValues.CFL_DRAFT_ROUND}
                            onFocus={handleInputFocus}
                        />
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("CFL_DRAFT_ROUND_TO", value)}
                            placeholder="To CFL Draft Round"
                            percent='12.5%'
                            value={formValues.CFL_DRAFT_ROUND_TO}
                            onFocus={handleInputFocus}
                        />
                        <div style={{ flexGrow: "1" }}></div>
                        <ModDropDown
                            options={chooseNational}
                            field="label"
                            fieldValue="value"
                            fieldName='IMPNIP'
                            label="Choose Nationality"
                            value={formValues.IMPNIP}
                            isOpen={dropdownOpen.IMPNIP}
                            percent="14%"
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("OPTION_YR", value)}
                            placeholder="FCY"
                            percent='14%'
                            value={formValues.OPTION_YR}
                            onFocus={handleInputFocus}
                        />
                    </div>
                </div>
                {/* NFL */}
                <div className="nfl container-fluid p-1">
                    <div className="testLine">
                        <ModDropDown
                            options={nflObject}
                            field="Team_Name"
                            fieldValue="Team"
                            fieldName='NFLTEAM'
                            label="NFL Team"
                            value={formValues.NFLTEAM}
                            isOpen={dropdownOpen.NFLTEAM}
                            percent='16.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={NFLStatus}
                            field="status"
                            fieldValue="status_id"
                            fieldName='NFLSTATUS'
                            label="NFL Status"
                            value={formValues.NFLSTATUS}
                            isOpen={dropdownOpen.NFLSTATUS}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={positionArray}
                            field='POS_DESC'
                            fieldValue='POS_SPEC_CODE'
                            fieldName='NFLPos'
                            label="NFL Position"
                            value={formValues.NFLPos}
                            isOpen={dropdownOpen.NFLPos}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={genPos}
                            field='title'
                            fieldValue='GeneralPos'
                            fieldName='NFLGP'
                            label="NFL GP"
                            value={formValues.NFLGP}
                            isOpen={dropdownOpen.NFLGP}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <div className="fixWords px-3 flex-grow-1"> Status:</div>
                        <FBXCalendar
                            fieldName='NFLStatusDateStart'
                            dateIn={formValues.NFLStatusDateStart}
                            minYear="1950"
                            maxYear="2035"
                            style={{ width: '14%' }}
                            placeholder="NFL Status Start"
                            onDateChange={(value) => handleDateChange('NFLStatusDateStart', value)} // Start date handler
                            openCalendar={openCalendar}
                            onToggleCalendar={handleToggleCalendar}
                            isOpen={openCalendar === 'NFLStatusDateStart'}
                        />
                        <FBXCalendar
                            fieldName='NFLStatusDateEnd'
                            dateIn={formValues.NFLStatusDateEnd}
                            minYear="1950"
                            maxYear="2035"
                            style={{ width: '14%' }}
                            placeholder="NFL Status End"
                            onDateChange={(value) => handleDateChange('NFLStatusDateEnd', value)} // Start date handler
                            openCalendar={openCalendar}
                            onToggleCalendar={handleToggleCalendar}
                            isOpen={openCalendar === 'NFLStatusDateEnd'}
                        />
                    </div>
                    <div className="s1line">
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("DRAFT_YEAR", value)}
                            placeholder="NFL Draft Yr."
                            percent='16.5%'
                            value={formValues.DRAFT_YEAR}
                            onFocus={handleInputFocus}
                        />
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("NFL_DRAFT_YEAR_TO", value)}
                            placeholder="To NFL Draft Yr."
                            percent='12.5%'
                            value={formValues.NFL_DRAFT_YEAR_TO}
                            onFocus={handleInputFocus}
                        />
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("NFL_DRAFT_ROUND", value)}
                            placeholder="NFL Draft Round"
                            percent='12.5%'
                            value={formValues.NFL_DRAFT_ROUND}
                            onFocus={handleInputFocus}
                        />
                        <S1Input
                            onKeyUpChange={(value) => updateS1OutputArray("NFL_DRAFT_ROUND_TO", value)}
                            placeholder="To NFL Draft Round"
                            percent='12.5%'
                            value={formValues.NFL_DRAFT_ROUND_TO}
                            onFocus={handleInputFocus}
                        />
                    </div>
                </div>
                {/* UFL24 */}
                <div className="ufl24 container-fluid p-1">
                    <div className="testLine">
                        <ModDropDown
                            options={ufl24Object}
                            field="Team_Name"
                            fieldValue="Team"
                            fieldName='UFL24TEAM'
                            label="UFL24 Team"
                            value={formValues.UFL24TEAM}
                            isOpen={dropdownOpen.UFL24TEAM}
                            percent='16.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={NFLStatus}
                            field="status"
                            fieldValue="status_id"
                            fieldName='UFL24STATUS'
                            label="UFL24 Status"
                            value={formValues.UFL24STATUS}
                            isOpen={dropdownOpen.UFL24STATUS}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={positionArray}
                            field='POS_DESC'
                            fieldValue='POS_SPEC_CODE'
                            fieldName='UFL24Pos'
                            label="UFL24 Position"
                            value={formValues.UFL24Pos}
                            isOpen={dropdownOpen.UFL24Pos}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <ModDropDown
                            options={genPos}
                            field='title'
                            fieldValue='GeneralPos'
                            fieldName='UFL24GP'
                            label="UFL24 GP"
                            value={formValues.UFL24GP}
                            isOpen={dropdownOpen.UFL24GP}
                            percent='12.5%'
                            onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                            onSelect={(field, value) => updateS1OutputArray(field, value)}
                        />
                        <div className="fixWords px-3 flex-grow-1"> Status:</div>
                        <FBXCalendar
                            fieldName='UFL24StatusDateStart'
                            dateIn={formValues.UFL24StatusDateStart}
                            minYear="1950"
                            maxYear="2035"
                            style={{ width: '14%' }}
                            placeholder="UFL24 Status Start"
                            onDateChange={(value) => handleDateChange('UFL24StatusDateStart', value)} // Start date handler
                            openCalendar={openCalendar}
                            onToggleCalendar={handleToggleCalendar}
                            isOpen={openCalendar === 'UFL24StatusDateStart'}
                        />
                        <FBXCalendar
                            fieldName='UFL24StatusDateEnd'
                            dateIn={formValues.UFL24StatusDateEnd}
                            minYear="1950"
                            maxYear="2035"
                            style={{ width: '14%' }}
                            placeholder="UFL24 Status End"
                            onDateChange={(value) => handleDateChange('UFL24StatusDateEnd', value)} // Start date handler
                            openCalendar={openCalendar}
                            onToggleCalendar={handleToggleCalendar}
                            isOpen={openCalendar === 'UFL24StatusDateEnd'}
                        />
                    </div>
                </div>
            </div>
        </DragBox2026>
    )
}

export default S1Search;
